
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./nation-login.cjs.production.min.js')
} else {
  module.exports = require('./nation-login.cjs.development.js')
}
